import React from 'react'
import {Spin, Button, message} from 'antd'
import common from '@/public/common'
import {ajaxApi,downloadApi} from '@/server'
import {  getParmUrl, outformat,getCookieNew } from '../../public/utils'
import moment from 'moment'

const apihost = common.scpUrl

class PrintScmOrder extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      sping: false,
      data: []
    }
  }
  componentDidMount () {
    this.setState({
      sping: true
    }, () => {
      this.getPrint()
    })
  }
    getPrint = () => {
      ajaxApi({
        url: apihost+ 'scs/order/print-po',
        params: {POID: getParmUrl('POID')}
      }).then(res => {
        if (res.data.code === 200) {
          this.setState({
            sping: false,
            data: res.data.data
          })
        } else {
          this.setState({
            sping: false,
            data: {}
          })
          message.error(res.data.error_message)
        }
      })
    }
    print = () => {
      window.document.body.innerHTML = window.document.getElementById('printDiv').innerHTML
      window.print()
      window.location.reload()
    }
    goback = () => {
      this.props.history.go(-1)
    }

    exportExcel=()=>{
      const { data } = this.state
      downloadApi(
        common.SapUrl + 'order/export-po',
          {po_id:getParmUrl('POID')},
          "采购单"+data.po_code + moment().format('YYYYMMDDHHmmss') + '.xls'
      )
    }
    render () {
      const { sping, data } = this.state
      return (<div className="returnList">
        <Spin spinning={sping}>
          <div>
            <div id="printDiv">
              <h2 style={{textAlign: 'center', fontWeight: '600', fontSize: '21px'}}>{data.title || '--'}</h2>
              <table cellpadding="0" cellspacing="0" border="1" style={{margin: '0px auto', width: '1000px', fontFamily: '微软雅黑', textAlign: 'center', borderCollapse: 'inherit'
              }}>
                <tbody><tr>
                  <td style={{ padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}} >{data.supplier_filed ? data.supplier_filed: '--'}</td>
                  <td style={{ width:'16%',padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>
                    <span >{data.supplier_name || '--'}</span>
                  </td>
                  <td id="create_filed" style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.create_filed ? data.create_filed :'--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>
                    <span id="lblOrderDate">{data.create_date ? moment(data.create_date).format('YYYY-MM-DD') : '--'}</span>
                  </td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}} id="expect_filed">{data.expect_filed ? data.expect_filed: '--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}} colspan="5">
                    <span id="lblExpectDate">{data.expect_date ? moment(data.expect_date).format('YYYY-MM-DD') : '--'}</span>
                  </td>
                </tr>
                <tr id="tableappendcontent">
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}} id="po_code_filed">{data.po_code_filed ? data.po_code_filed: '--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>
                    <span id="lblOrderCode">{data.po_code || '--'}</span>
                  </td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}} id="contract_name_filed">{data.contract_name_filed ? data.contract_name_filed: '--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}} id="contract_name">{data.contract_name || '--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}} id="contract_tel_filed">{data.contract_tel_filed ? data.contract_tel_filed : '--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}} colspan="5" id="contract_tel">{data.contract_tel || '--'}</td>
                </tr>
                <tr><td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.product_code_filed || '--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.product_name_filed || '--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>供应商货品编码</td>
                  {getParmUrl("hasErpCode")?<td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>定制片参数</td>:<td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.color_filed || '--'}</td>}
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.price_quantity_filed || '--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.free_quantity_filed || '--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.unit_price_filed || '--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.price_filed || '--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.money_type_filed || '--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.unit_filed || '--'}</td>
                </tr>

                {
                  data.items && data.items.length
                    ? data.items.map(a => {
                      return a.products.length ? [...a.products, {}].map((b, index) => index == a.products.length
                        ? <tr>
                          <td colspan="4" style={{padding: '3px', border: '1px solid #000000'}}>{data.sub_total_filed || '--'}</td>
                          <td style={{padding: '3px', border: '1px solid #000000'}}>{outformat(a.sub_total_price_quantity)}</td>
                          <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{outformat(a.sub_total_free_quantity)}</td>
                          <td style={{padding: '3px', border: '1px solid #000000'}}></td>
                          <td style={{padding: '3px', border: '1px solid #000000'}}>{outformat(a.sub_total_price ? outformat(a.sub_total_price ? a.sub_total_price.toFixed(2) : 0) : 0)}</td>
                          <td style={{padding: '3px', border: '1px solid #000000'}}></td>
                          <td style={{padding: '3px', border: '1px solid #000000'}}></td>
                        </tr>
                        : <tr>
                          <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{b.product_code || '--'}</td>
                          <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{b.product_name || '--'} </td>
                          <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{b.third_product_code || '--'}</td>
                          {getParmUrl("hasErpCode")?<td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{b.customized_arg_list?b.customized_arg_list.map(e=>{
            return <div>{e}</div>
          }):'--'}</td>:<td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{b.color || '--'}</td>}
                          <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{outformat(b.price_quantity)}</td>
                          <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{outformat(b.free_quantity)}</td>
                          <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{outformat(b.base_price ? b.base_price.toFixed(4) : 0)}</td>
                          <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{outformat(b.price ? b.price.toFixed(2) : 0)}</td>
                          <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{b.money_type || '--'}</td>
                          <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{b.unit || '--'}</td>
                        </tr>) : null
                    }

                    )

                    : null
                }

                <tr><td colspan="4" style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.total_money_filed || '--'}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{outformat(data.total_price_quantity)}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{outformat(data.total_free_quantity)}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}></td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{outformat(data.total_money ? data.total_money.toFixed(2) : 0)}</td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}></td>
                  <td style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}></td></tr>

                <tr>
                  <td rowspan="6" id="note_filed" style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.note_filed ? data.note_filed: '--'}</td>
                  <td colspan="9" rowspan="6" style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>
                    <span id="lblRemark" style={{'text-align': 'left', float: 'left'}} dangerouslySetInnerHTML={{__html: data.note || '--'}}>

                    </span>
                  </td>
                </tr>
                <tr>
                </tr>
                <tr>
                </tr>
                <tr>
                </tr>
                <tr>
                </tr>
                <tr>
                </tr>
                <tr>
                  <td id="receive_name_filed" style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.receive_name_filed ? data.receive_name_filed: '--'}</td>
                  <td id="receive_name" style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.receive_name || '--'}</td>
                  <td id="receive_tel_filed" style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.receive_tel_filed ? data.receive_tel_filed: '--'}</td>
                  <td colspan="8" style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>
                    <span id="lblTel">{data.receive_tel || '--'}</span>
                  </td>
                </tr>
                <tr>
                  <td id="receive_warehouse_filed" style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.receive_warehouse_filed ? data.receive_warehouse_filed: '--'}</td>
                  <td colspan="3" id="receive_warehouse" style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.receive_warehouse || '--'}</td>

                  <td id="receive_address_filed" style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>{data.receive_address_filed ? data.receive_address_filed: '--'}</td>
                  <td colspan="5" style={{padding: '3px', borderLeft: '1px solid #000000', borderRight: '1px solid #000000'}}>
                    <span id="lblDeliveryAddress" >{data.receive_address || '--'}</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <p style={{textAlign: 'center', margin: '20px 0'}}>
              <Button type="primary" shape="round" onClick={this.print}>{data.print_filed || '--'}</Button>
              <Button shape="round" style={{marginLeft: '25px'}} onClick={this.goback}>{data.return_back_filed || '--'}</Button>
              <Button shape="round" style={{marginLeft: '25px'}} onClick={this.exportExcel}>{data.export_filed || '--'}</Button>
            </p>
          </div>
        </Spin>
      </div>)
    }
}
export default PrintScmOrder



// WEBPACK FOOTER //
// ./src/pages/orderAdmin/printScmOrder.js